import React, {
  Dispatch,
  FocusEventHandler,
  KeyboardEvent,
  SetStateAction,
} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

interface Props {
  loadingProducts: boolean;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  onFocus: FocusEventHandler<HTMLInputElement>;
  onSearch: () => void;
}

export const SearchTermInput: React.FC<Props> = ({
  loadingProducts,
  searchTerm,
  setSearchTerm,
  onFocus,
  onSearch,
}) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
    }}
  >
    <TextField
      id="products-search"
      inputProps={{ "data-testid": "catalog-search-input" }}
      label="Search for Products or Vendors..."
      type="search"
      value={searchTerm}
      onFocus={onFocus}
      onChange={(e) => {
        setSearchTerm(e.target.value);
      }}
      onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
        e.key === "Enter" && !loadingProducts && onSearch()
      }
      style={{
        width: "500px",
        background: "#FFFFFF",
      }}
    />

    <Button
      id="products-search-button"
      data-testid="catalog-search-submit"
      variant="contained"
      color="primary"
      size="large"
      disabled={loadingProducts || searchTerm.length === 0}
      onClick={onSearch}
    >
      search
    </Button>
  </div>
);

SearchTermInput.displayName = "SearchTermInput";
